import VerifiedIcon from "@/assets/icons/verified.svg";
import DefaultProfile from "@/assets/graphics/default-profile.svg";
import { ImageTypeHandler } from "../ImageTypeHandler";
import { ImagePlaceholder } from "../Image/types";

export interface Props {
  imageUrl: string;
  imagePlaceholder?: ImagePlaceholder;
  fullName?: string;
}

const ArtistVerified = ({ imageUrl, imagePlaceholder, fullName }: Props) => {
  return (
    <div>
      <div className="relative w-20 h-20">
        {imageUrl ? (
          <ImageTypeHandler
            src={imageUrl}
            placeholder={imagePlaceholder}
            alt={fullName || "profile image"}
            className="rounded-full"
            fill
          />
        ) : (
          <DefaultProfile />
        )}
        <div className="bg-primary w-[30px] h-[30px] rounded-full absolute top-14 left-14 flex items-center justify-center">
          <VerifiedIcon className="w-5 h-5 fill-blue " />
        </div>
      </div>
    </div>
  );
};

export default ArtistVerified;
